import { getCaseListDisplayName } from "~/pages/Compliance/CaseDetailsDrawer/CaseDetailsHeader/utils";
import { formatShortFormDate } from "~/utils/datetime";
import { ProposedCaseRows, ProposedCasesGridRowItem } from "../../../types";

export const transformRowData = (rows: ProposedCaseRows) => {
  const rowData: ProposedCasesGridRowItem[] = rows.map((row) => ({
    id: row.id,
    caseName: getCaseListDisplayName(row),
    program: row.program?.name ?? "",
    caseType: row.caseType,
    creationDate: formatShortFormDate(row.createdAt),
    status: row.status,
    resolution: row.resolution,
    assignee: row.assignee?.externalUser?.name ?? "",
  }));
  return rowData;
};
